import React from 'react';
import cx from 'classnames';
import T from 'i18n-react';

import ClearAllButton from 'Components/pages/VehiclesList/FiltersHeader/ClearAllButton';
import useFilterView from 'Components/VehicleList/filters/useFilterView';
import { useSeenFilter } from 'Components/VehicleList/SeenFilter';
import { triggerClearAllFiltersButtonClickedEvent } from 'Services/analytics/events';
import { useResetFilters } from 'Utilities/hooks/vehicleList/useResetFilters';
import { VIEWING_FILTER } from 'Utilities/seenVehicles/seenVehicles';

import styles from './NotFoundFilters.module.scss';

T.setTexts(require('Components/texts.json'));

const NotFoundFilters = () => {
	const resetFilters = useResetFilters();
	const { isExpandableFilter } = useFilterView();
	const [, setSeenFilter] = useSeenFilter();

	const onClearFilters = () => {
		triggerClearAllFiltersButtonClickedEvent();
		resetFilters();
		setSeenFilter(VIEWING_FILTER.ALL);
	};

	return (
		<div className={styles.notFound}>
			<h2 className={cx('mw-title-title2', { 'mw-mt-1': isExpandableFilter }, styles.title)}>
				{T.translate('vehicleList.notFound.title')}
			</h2>
			<p className={cx(isExpandableFilter ? 'mw-mt-1' : 'mw-mt-2', styles.secondTitle)}>
				{T.translate('vehicleList.notFound.body')}
			</p>
			<ClearAllButton onClick={onClearFilters} text={T.translate('vehicleList.filters.clearFilters')} />
		</div>
	);
};

export default NotFoundFilters;
